/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniPaperAirplane = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-paper-airplane ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M3.10526 2.28844C2.85362 2.25277 2.60104 2.34697 2.43421 2.5387C2.26738 2.73044 2.209 2.99361 2.27911 3.2379L3.69276 8.16378C3.87733 8.80688 4.4655 9.25 5.13456 9.25H11.25C11.6642 9.25 12 9.58579 12 10C12 10.4142 11.6642 10.75 11.25 10.75H5.13457C4.4655 10.75 3.87733 11.1931 3.69277 11.8362L2.27911 16.7621C2.209 17.0064 2.26738 17.2696 2.43421 17.4613C2.60104 17.6531 2.85362 17.7473 3.10526 17.7116C8.94303 16.8842 14.221 14.3187 18.3983 10.5574C18.5563 10.4151 18.6465 10.2126 18.6465 10C18.6465 9.78746 18.5563 9.58489 18.3983 9.44266C14.221 5.68129 8.94303 3.11585 3.10526 2.28844Z"
        fill="#7041F1"
      />
    </svg>
  );
};
